









































import Vue from "vue";
import AdminStatusTag from "./AdminStatusTag.vue";
export default Vue.extend({
  components: { AdminStatusTag },
  props: ["admin", "is_sys_user"],
  setup() {
    return {};
  },
});
